<template>
  <div class="container">
    <Header />
    <div class="content">
      <div v-if="step == 1">
        <div class="title">
          <span>验证身份</span>
        </div>
        <div class="subtitle">为了保证您的账号安全，请验证身份，验证成功后进行下一步操作</div>
        <!-- 分割线 -->
        <div class="divider">
          <el-divider></el-divider>
        </div>
        <div class="table">
          <div class="VerificationCode">
            <div class="phone_num">使用 {{stuPhone}} 验证</div>
            <div class="password">
              <div>
                <el-input style="width:235px;" placeholder="请输入验证码" maxlength="6" clearable  v-model="captcha"></el-input>
              </div>
              <el-button  @click="getCaptcha" :class="{active: getCode}"  class="button">{{getCodeTxt}}</el-button>
            </div>
            <div class="password2">
              <span class="Voice">收不到短信，试试语音验证码</span>
            </div>
            <el-button class="password3" @click="nextStep">下一步</el-button>
          </div>
        </div>
      </div>
      <div v-if="step == 2">
		  <div class="title">
			  <span>修改密码</span>
		  </div>
		  <div class="subtitle" style="color: red;">修改成功后，将重新登录，请牢记新密码！</div>
		  <!-- 分割线 -->
		  <div class="divider">
			  <el-divider></el-divider>
		  </div>
		  <div class="table">
			<div class="VerificationCode">
			  <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="新密码" prop="pass">
				  <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="checkPass">
				  <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item>
				  <el-button type="primary btn" @click="submitForm('ruleForm')">确认</el-button>
				</el-form-item>
			  </el-form>
			</div>
		  </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import {getUserInfo}  from "../utils/api"
import api from "../axios/interface"
export default {
  name: "ChangePassword",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      step: 2,//不验证手机号
      stuPhone: "",
      getCodeTxt: "获取验证码",
      isCountDown: false,
      getCode: false,
      captcha: '',
      ruleForm: {
        pass: '',
        checkPass: '',
      },
      rules: {
        pass: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ],
      }
    };
  },
  components: {
    Header: Header,
    Footer: Footer
  },
  mounted() {
    this.init()
  },
  methods: {
    init(){
      let userInfo = getUserInfo()
      this.stuPhone = userInfo.phone
    },

    submitForm(formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.get(api.UPDATEPAW, {captcha:this.captcha,password: this.ruleForm.pass}, { hideMessage: true } )
            .then(res => {
              this.$message({
                showClose: true,
                message: '修改成功',
                duration: 2000,
                type: 'info'
              });
              that.$router.push({
                name: "login"
              });
            })
            .catch(res => {});
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    // 获取验证码
    getCaptcha() {
      let that = this;
      if(!this.isCountDown){
         this.$axios.get(api.SENDCAPTCHA, {}, { hideMessage: true } )
          .then(res => {
            that.countDown();
          })
        .catch(res => {});
      }
    },

    /**
     * 验证码定时器
     */
    countDown() {
      let time = 60;
      const that = this;
      this.isCountDown = true;
      this.t = setInterval(function () {
          if (time === 0) {
              that.clearInterval()
          } else {
              that.getCodeTxt = time + ' s';
              that.getCode = true;
              time--
          }
      }, 1000)
    },

    /**
     * 清除定时器
     */
    clearInterval() {
      clearInterval(this.t);
      this.getCodeTxt = '发送验证码';
      this.isCountDown = false
    },

    nextStep() {
      if(this.captcha){
        this.step = 2
      }else {
        this.$message({
          showClose: true,
          message: '请正确填写手机验证码',
          duration: 1000,
          type: 'info'
        });
      }
    }
  },

  // watch:{

  // }
};
</script>

<style lang="less" scoped>
.header {
  background-color: #fff;
}
.content {
  width: 1100px;
  margin: 90px 50px 0 50px;
  height: 614px;
  text-align: center;
  border-radius: 10px;
  background: #fff;
  display: flex;
  flex-direction: column;
}
.content .title {
  width: 1100px;
  height: 37px;
  padding-top: 73px;
  font-size: 32px;
  color: #4d4d4d;
}
.subtitle {
  width: 1100px;
  height: 18px;
  font-size: 15px;
  color: #9999;
  margin-top: 20px;
}
.btn {
  width: 100%;
}
.divider {
  width: 80%;
  margin-left: 10%;
  margin-top: 25px;
}
.VerificationCode {
  width: 417px;
  height: 176px;
  margin: 0 auto;
  margin-top: 88px;
  .phone_num {
    text-align: left;
    margin-bottom: 15px;
    color: #333333;
  }
  .password3 {
    width: 417px;
    height: 40px;
    margin-top: 53px;
    text-align: center;
    border-radius: 5px;
    background-color: #0079fe;
    font-size: 15px;
    color: #fff;
  }
  .password {
    width: 410px;
    height: 40px;
    display: flex;
    flex-direction: row;
    .input {
      display: block;
    }
    .button {
      cursor: pointer;
      margin-left: 25px;
      width: 150px;
      height: 40px;
      display: block;
      text-align: center;
      border-radius: 5px;
      background-color: #0079fe;
      font-size: 15px;
      color: #fff;
    }
  }
   .password2 {
    width: 417px;
    height: 14px;
    margin-top: 27px;
    .Voice {
      width: 182px;
      height: 19px;
      float: right;
      font-size: 14px;
      color: #797979;
      text-decoration: none;
    }
  }
}
</style>
